import { Button, Card, EditIcon, Flex, Typography } from '@iheartjane/reefer';
import { useFormContext } from '@iheartjane/reefer-hook-form';
import { Table } from '@iheartjane/reefer-table';
import { useEffect, useState } from 'react';

import { CollapsedBorderTable } from '@jane/business-admin/components/TableWithBorderSeparator';
import type {
  AbbreviatedMenuRow,
  StoreSettingsPayload,
} from '@jane/business-admin/types';
import { MODAL_CARD_WIDTH } from '@jane/business-admin/util';

import { MenuRowsModal } from './MenuRowsModal';
import { Row } from './Row';
import { LoadingMenuRows } from './Skeleton';

export const MenuRowsCard = ({
  isLoading,
  menuRowModalOpen,
  rows,
  setMenuRowModalClose,
  setMenuRowModalOpen,
  store,
}: {
  isLoading: boolean;
  menuRowModalOpen: boolean;
  rows?: AbbreviatedMenuRow[];
  setMenuRowModalClose: (name?: string) => void;
  setMenuRowModalOpen: (name?: string) => void;
  store?: StoreSettingsPayload;
}) => {
  const { setValue } = useFormContext();
  const [selectedMenuRows, setSelectedMenuRows] = useState<
    AbbreviatedMenuRow[]
  >([]);

  useEffect(() => {
    if (rows) {
      setSelectedMenuRows(rows);
    }
  }, [rows]);

  useEffect(() => {
    setValue('custom_rows', selectedMenuRows);
  }, [selectedMenuRows]);

  return (
    <Card border="grays-light" width={MODAL_CARD_WIDTH} mb={32}>
      <Card.Content>
        <Flex p={24} flexDirection="column">
          {isLoading ? (
            <LoadingMenuRows />
          ) : (
            <>
              <Flex
                justifyContent="space-between"
                alignItems="center"
                mb={selectedMenuRows.length > 0 ? 40 : 0}
              >
                <Typography variant="h2-semibold">Menu rows</Typography>
                <Button.Icon
                  ariaLabel="edit menu products product groups"
                  icon={<EditIcon />}
                  variant="secondary"
                  onClick={() => setMenuRowModalOpen()}
                />
              </Flex>
              {selectedMenuRows.length > 0 && (
                <CollapsedBorderTable>
                  <Table.Head>
                    <Table.Row>
                      <Table.HeaderCell>
                        <Typography variant="caps-regular" color="grays-mid">
                          Name
                        </Typography>
                      </Table.HeaderCell>
                      <Table.HeaderCell>
                        <Typography variant="caps-regular" color="grays-mid">
                          Visibility
                        </Typography>
                      </Table.HeaderCell>
                    </Table.Row>
                  </Table.Head>
                  <Table.Body>
                    {selectedMenuRows
                      .sort((a, b) => Number(b.enabled) - Number(a.enabled))
                      .map((row, index) => {
                        const isLast = index + 1 === selectedMenuRows.length;

                        return (
                          <Row hideBottomBorder={isLast} key={row.id}>
                            <Table.Cell width="75%">
                              <Typography>{row.custom_display_name}</Typography>
                            </Table.Cell>
                            <Table.Cell>
                              <Typography>
                                {row.enabled ? 'On' : 'Off'}
                              </Typography>
                            </Table.Cell>
                          </Row>
                        );
                      })}
                  </Table.Body>
                </CollapsedBorderTable>
              )}
            </>
          )}

          {menuRowModalOpen && (
            <MenuRowsModal
              initiallySelected={selectedMenuRows}
              open
              store={store}
              setSelected={setSelectedMenuRows}
              onClose={() =>
                setMenuRowModalClose('edit-menu-products-product-groups')
              }
            />
          )}
        </Flex>
      </Card.Content>
    </Card>
  );
};
